/** 分 → "12.34" (元, 两位小数) */
export function fenToYuan(fen: number | null | undefined): string {
  const n = Number(fen ?? 0);
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(Math.trunc(n));
  return `${sign}${Math.floor(abs / 100)}.${String(abs % 100).padStart(2, "0")}`;
}

export function fmtTime(s: string | null | undefined): string {
  return s ? s.replace("T", " ").slice(0, 19) : "-";
}

export const INSUFFICIENT_CREDITS = "余额不足，请充值";

/**
 * 单价输入框 (元, 最多两位小数) → 分。
 *   ""/空白 → null (使用默认); 非法 (负数 / 超过两位小数 / 非数字 / 过大) → undefined。
 * 用字符串拆分而不是 parseFloat * 100, 避免 0.29 * 100 = 28.999… 之类的浮点误差。
 */
export function parseYuanToFen(input: string): number | null | undefined {
  const s = input.trim();
  if (s === "") return null;
  const m = /^(\d{0,7})(?:\.(\d{0,2}))?$/.exec(s);
  if (!m || !/\d/.test(s)) return undefined;
  return Number(m[1]) * 100 + Number((m[2] ?? "").padEnd(2, "0"));
}
